module.exports = __webpack_public_path__ + "static/media/spinner.baeaf0c7.gif";